import { CompensationUnit } from "@prisma/client";

export const compensationUnitToLabel = {
  [CompensationUnit.HOUR]: "Hour",
  [CompensationUnit.DAY]: "Day",
  [CompensationUnit.WEEK]: "Week",
  [CompensationUnit.MONTH]: "Month",
  [CompensationUnit.YEAR]: "Year",
};
